<div *ngIf="enableDealsHub && showDealsHub && !isBonusPath">
    <div *ngIf="launchpadData?.welcomeText" class="w-100 d-flex">
        <launchpad-headline-al-v1 [lifetimeSavingsAmount]="lifetimeSavingsData" [props]="launchpadData?.welcomeText"></launchpad-headline-al-v1>
    </div>
    <main *ngIf="tileContent !== undefined && tileContent.length > 0" (click)="onTileClick($event)">
        <launchpad-al-v1 [props]="tileContent"></launchpad-al-v1>
    </main>
</div>
